import React from 'react';
import styled from 'styled-components';
import {Typography} from "antd";
import {NavLink} from "react-router-dom";
import DateNews from "./DateNews";
import {ROUTES, formatPath} from "../constants/PathRoutes";
import {GREE_1, BORDER_GRAY} from "../utils/colors";

const {Paragraph} = Typography;

const CardContainer = styled(NavLink)`
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    background: white;
    border: 1px solid ${BORDER_GRAY};
    transition: all 0.3s ease;
    text-decoration: none;
    color: inherit;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
        border-color: ${GREE_1};
    }
`;

const ImageContainer = styled.div`
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    border-radius: 6px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

const Title = styled.h4`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${GREE_1};
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Preview = styled(Paragraph)`
    margin: 0 !important;
    font-size: 12px;
    color: #666;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const StyledDateNews = styled(DateNews)`
    font-size: 11px;
    color: #999;
`;

export default function CardRecentNews({image, date, title, slug, resume = '', baseRoute = ROUTES.BLOG}) {
    const truncateText = (text, maxLength = 100) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength).trim() + '...';
    };

    const detailRoute = `${baseRoute}/${slug}`;

    return (
        <CardContainer to={detailRoute}>
            <ImageContainer>
                <img src={image} alt={title} />
            </ImageContainer>
            <ContentContainer>
                <StyledDateNews value={date} />
                <Title>{title}</Title>
                {resume && <Preview>{truncateText(resume, 100)}</Preview>}
            </ContentContainer>
        </CardContainer>
    );
}